import type { ConversionOption } from "@/common/types/chart";

export const trialBalanceQueryDefaults: {
  conversion: ConversionOption;
} = {
  conversion: "at_cost",
};
